import { UpdateTemplatesEditor } from '../app/work/templates';

export function TemplatesSettingsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-[19px] font-semibold tracking-tight">Update templates</h2>
        <p className="text-sm text-muted-foreground">
          The wording LawBee uses for client case updates when a matter changes stage. Variables in braces are filled in for each client and matter.
        </p>
      </div>
      <UpdateTemplatesEditor />
    </div>
  );
}
